import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AvailableAllariaMasAccount,
  MainHolder,
  UnifiedBalanceActions,
} from "../../components/UnifiedBalance/types/types";
import { UserAccount } from "../../types/types";

interface UnifiedBalanceInitialState {
  openModal: boolean;
  action: UnifiedBalanceActions;
  selectedAccount: Pick<UserAccount, "number" | "name">;
  allariaMasSelectedAccount: AvailableAllariaMasAccount | null;
  assessmentData: {
    availablesAllariaMasAccounts: AvailableAllariaMasAccount[];
    assessment: {
      required_action: string;
      is_allowed: boolean;
      failed_reason?: string;
    };
    mainHolders: MainHolder[];
    allaria_account: {
      number: string;
      denomination: string;
      juridical: boolean | null;
    };
  };
  returnToDepositModal?: boolean;
}

const initialState: UnifiedBalanceInitialState = {
  openModal: false,
  action: "INITIAL",
  selectedAccount: {
    name: "",
    number: "",
  } as Pick<UserAccount, "name" | "number">,

  allariaMasSelectedAccount: null,
  assessmentData: {
    availablesAllariaMasAccounts: [],
    assessment: {
      required_action: "",
      is_allowed: false,
    },
    mainHolders: [],
    allaria_account: {
      number: "",
      denomination: "",
      juridical: null,
    },
  },
  returnToDepositModal: false,
};

const transactionSlice = createSlice({
  name: "unifiedBalance",
  initialState,
  reducers: {
    updateSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
    updateAction: (state, action) => {
      state.action = action.payload;
    },

    updateAllariaMasSelectedAccount: (state, action) => {
      state.allariaMasSelectedAccount = action.payload;
    },
    updateAssessmentData: (state, action) => {
      state.assessmentData = action.payload;
    },
    resetFields: (state) => {
      state.selectedAccount = initialState.selectedAccount;
      state.assessmentData = initialState.assessmentData;
      state.allariaMasSelectedAccount = initialState.allariaMasSelectedAccount;
    },
    openModal: (
      state,
      action: PayloadAction<{ returnToDepositModal: boolean } | undefined>
    ) => {
      state.openModal = true;
      state.returnToDepositModal = !!action?.payload?.returnToDepositModal;
    },
    closeModal: (state) => {
      state.openModal = false;
      state.action = initialState.action;
      state.selectedAccount = initialState.selectedAccount;
      state.assessmentData = initialState.assessmentData;
      state.allariaMasSelectedAccount = initialState.allariaMasSelectedAccount;
    },
  },
});

export const {
  openModal,
  closeModal,
  updateAction,
  updateSelectedAccount,
  updateAllariaMasSelectedAccount,
  updateAssessmentData,
  resetFields,
} = transactionSlice.actions;
export default transactionSlice.reducer;
